import { Star } from 'lucide-react';
import React from 'react';

interface CoinProps {
  children?: React.ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeConfig = {
  xs: {
    width: '1rem',
    height: '1rem',
    fontSize: '0.75rem',
    starSize: 24,
  },
  sm: {
    width: '2rem',
    height: '2rem',
    fontSize: '1rem',
    starSize: 32,
  },
  md: {
    width: '3rem',
    height: '3rem',
    fontSize: '1.5rem',
    starSize: 48,
  },
  lg: {
    width: '4rem',
    height: '4rem',
    fontSize: '2rem',
    starSize: 64,
  },
};

const Coin: React.FC<CoinProps> = ({
  children,
  size = 'md',
  className = '',
}) => {
  const config = sizeConfig[size];

  return (
    <div
      className={`d-flex align-items-center justify-content-center rounded-circle fw-bold bg-warning position-relative ${className}`}
      style={{
        width: config.width,
        minWidth: config.width,
        height: config.height,
        fontSize: config.fontSize,
        color: 'brown',
      }}
    >
      <Star
        size={config.starSize}
        className="position-absolute opacity-25"
        strokeWidth={2}
        color="GoldenRod"
      />
      <span className="position-relative" style={{ zIndex: 1 }}>
        {children}
      </span>
    </div>
  );
};

export default Coin;
export type { CoinProps };
